module.exports = __webpack_public_path__ + "img/courseCatalogCover.6e2d4c0b.jpg";